<script>
import AkButtonActionV2 from '@components/v2/general/AkButtonActionV2.vue';
import {Dropdown} from 'floating-vue';

export default {
  components: {
    AkButtonActionV2,
    Dropdown,
  },
  props: {
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    id: {
      type: String,
      required: false,
      default: undefined,
    },
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },

    information: {
      type: String,
      required: false,
      default: undefined,
    },
    labelClass: {
      type: String,
      required: false,
      default: '',
    },
    showLabel: {
      type: Boolean,
      required: false,
      default: true,
    },
    className: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  methods: {},
};
</script>

<template>
  <div
    :class="[
      {
        'mb-2.5': !inline,
        'items-baseline': information,
        'items-center': !information,
        'min-h-[24px]': !this.$isMobile(),
      },
      className,
    ]"
    class="flex"
    v-if="this.showLabel || information">
    <label v-if="this.showLabel" :for="id" class="font-inter font-semibold text-base text-grey-900" :class="labelClass">
      <slot />
      <span class="text-red font-semibold">{{ required ? ' *' : '' }}</span></label
    >
    <div class="flex gap-2" :class="{'flex-1 justify-end': !this.showLabel}">
      <Dropdown theme="information" v-if="information">
        <!-- This will be the popover reference (for the events and position) -->
        <span
          class="ga-icon ga-question rounded-full text-grey-400 text-sm flex items-center justify-center bg-[#F5F6F8] w-[24px] h-[24px] hover:cursor-pointer"></span>
        <!-- This will be the content of the popover -->
        <template #popper>
          <div
            class="font-inter text-grey-500 font-medium !text-sm break-words text-pretty leading-normal"
            v-html="information"></div>
        </template>
      </Dropdown>

      <slot name="link" />
    </div>
  </div>
</template>
